exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./more.svg"));

// Module
exports.push([module.id, ".image-more-info-info-box-mZEs4{line-height:12px}.image-more-info-container-qtizD{width:28px;height:14px;background-image:url(" + ___CSS_LOADER_URL___0___ + ");background-color:rgba(0,0,0,.5);background-position:50%;background-size:cover;border-radius:3px}.image-more-info-container-qtizD:hover{background-color:#000}", ""]);

// Exports
exports.locals = {
	"info-box": "image-more-info-info-box-mZEs4",
	"container": "image-more-info-container-qtizD"
};